












































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import CustomUploader from "./components/CustomUploader.vue";
import { Button } from "vant";

import moment from "moment";
import pinyin from "pinyin";

const createAccountModule = namespace("createAccount");
const commonModule = namespace("common");

@Component({
  name: "IDCardUpload",
  components: {
    customUploader: CustomUploader,
    [Button.name]: Button
  }
})
export default class IDCardUpload extends Vue {
  @createAccountModule.Getter("open_mode_info") open_mode_info: any;
  @createAccountModule.Getter("id_card_photo") id_card_photo: any;
  @createAccountModule.Mutation("SAVE_ID_CARD_OCR_INFO") saveIDCardOcrInfo: any;
  @commonModule.Mutation("SAVE_NAV_TITLE") saveNavTitle: any;
  @createAccountModule.Getter("id_card_ocr_info") id_card_ocr_info: any;

  positive_img = {
    url: "",
    content: ""
  };
  inverse_img = {
    url: "",
    content: ""
  };
  positive_img_base64: string = '';
  inverse_img_base64: string = '';

  submitBtnText: any = "";

  get isSubmitDisabled() {
    return !this.positive_img.url || !this.inverse_img.url;
  }

  @Watch("open_mode_info", { deep: true, immediate: true })
  watchOpenModeInfo(val) {
    const { open_status } = val;
    this.submitBtnText =
      open_status == 1
        ? this.$t("open_account.idcard_upload.submit_btn_text1")
        : this.$t("open_account.idcard_upload.submit_btn_text2");
    // const navTitle: any =
    //   open_status == 1
    //     ? this.$t("open_account.idcard_verify.nav_title1")
    //     : this.$t("open_account.idcard_verify.nav_title2");
    // document.title = navTitle;
    // this.saveNavTitle(navTitle);
  }

  @Watch("id_card_photo", { deep: true, immediate: true })
  watchIDCardPhoto(val) {
    const { modify } = this.$route.query;
    if (!modify) return;
    const { positive_img, inverse_img } = val;
    this.positive_img = positive_img || {
      url: "",
      content: ""
    };
    this.inverse_img = inverse_img || {
      url: "",
      content: ""
    };
  }

  afterUpload(e, key){
    const nk = key + '_base64';
    this[nk] = e.file.content || e.file.base64;
  }

  handleAfterUploadFace(res) {
    this.positive_img = res;
  }

  handleAfterUploadBack(res) {
    this.inverse_img = res;
  }

  setNamePinyin(name) {
    const pinyinArr = pinyin(name, { style: pinyin.STYLE_NORMAL });
    const res = pinyinArr.map(item => {
      return item[0];
    });
    return res.join(" ");
  }

  handleSaveIdCardPhoto() {
    // 保存身份证信息
    const { open_status } = this.open_mode_info;
    (this as any).$apis
      .saveIdCardPhoto({
        type: 1,
        inverse_img: this.inverse_img.content,
        positive_img: this.positive_img.content,
        open_status
      })
      .then(res => {
        
        if (open_status == "1") {
          // 上传2张
          this.ocrIdCardPhoto(this.positive_img.url, 1);
        } else {
          this.saveIDCardOcrInfo({});
          this.$router.push({
            path: "/idcard-verify",
            query: this.$route.query
          });
        }
      })
      .catch(e => {
        
      });
  }
  isValidDate(dateStr){
    return !isNaN(dateStr);
  }

  // url 图片路径  type 1正面 2反面
  ocrIdCardPhoto(url, type) {
    // ocr识别身份证
    const params = new FormData();
    params.append("type", "1");
    params.append("card_img", this.positive_img.url);
    (this as any).$apis
      .ocrIdCardPhoto({
        type,
        card_img: url,
        base64_content: type == 1 ? this.positive_img_base64 : this.inverse_img_base64
      })
      .then(async (res) => {
        
        const _this = (this as any);

        if(type === 1){
          const {
            ocr: { birth, address, name, num, sex }
          } = res;
          /**
           * 跟据ocr的address匹配对应的省市区
           */
          const addRes = await _this.$apis.grepAddress({
            address
          });
          const {
            address: addressNew,
            area,
            city,
            city_code,
            country_code,
            province,
            province_code
          } = addRes;
          this.saveIDCardOcrInfo({
            birth: birth ? moment(birth).format("YYYY-MM-DD") : "",
            detail_address: addressNew,
            country_name: area,
            country_code,
            city_name: city,
            city_code,
            province_name: province,
            province_code,
            real_name: name,
            english_name: this.setNamePinyin(name),
            id_card: num,
            sex: sex == "男" ? 1 : 2
          });
          this.ocrIdCardPhoto(this.inverse_img.url, 0);
        }else{
          const { end_date, start_date } = res.ocr;
          const newData = {
            ..._this.id_card_ocr_info,
            end_date: this.isValidDate(end_date) ? moment(end_date).format("YYYY-MM-DD") : end_date,
            start_date: start_date ? moment(start_date).format("YYYY-MM-DD") : ""
          };
          this.saveIDCardOcrInfo(newData);
          // this.$router.push({
          //   path: "/idcard-verify",
          //   query: this.$route.query
          // });
        }
      })
      .catch(e => {
        
      }).finally((f)=>{
        this.$router.push({
          path: "/idcard-verify",
          query: this.$route.query
        }).catch(()=>{

        });
    });
  }
}
